export default {
  baseUrl: '/gfw'
}
